import { GetterTree } from 'vuex';
import { ProjectModule } from './types';
import { RootModule } from '../root-module';
import { Category, Task, Week, Project, DisplayOptions, TaskDay, Employee } from '@/types/store-types';

export const getters: GetterTree<ProjectModule, RootModule> = {

  displayOptions(state): DisplayOptions {
    return state.displayOptions;
  },

  project(state): Project {
    return state.projectData;
  },

  categories(state): Category[] {
    return state.categories;
  },

  tasks(state): Task[] {
    return state.tasks;
  },

  selectedTasks(state): number {
    return state.selectedTasks.length;
  },

  weeks(state): Week[] {
    return state.weeks;
  },

  days(state): TaskDay[] {
    return state.days;
  },

  allWeeksClosed(state): boolean {
    return state.weeks.find((w) => w.closed === false) === undefined;
  },

  employees(state): Employee[] {
    return state.employees;
  },

  employeeList(state): Employee[] {
    return state.employeeList;
  },
};
